import React, { useEffect, useState } from 'react'
import './Authentication.scss'
import { Link } from 'react-router-dom'

export default function ResetSuccessfull() {
  const [currentLanguage, setCurrentLanguage] = useState("");

  useEffect(() => {
    setCurrentLanguage(localStorage.getItem("language"));
  }, []);

  return (
    <div className='reset_success'>
      <div className="icon">
        <img src={`${process.env.PUBLIC_URL}/images/survey/thankyou.svg`} alt="" />
      </div>
      <div className="success_text">
        {currentLanguage === "Italian" 
          ? "La tua password è stata reimpostata con successo. Effettua il login con la tua nuova password per continuare."
          : "Your password has been reset successfully. Please login with your new password to continue."
        }
      </div>
      <div className="action mb15">
        <Link to='/auth'>
          {currentLanguage === "Italian" ? "Accedi" : "Login"}
        </Link>
      </div>
    </div>
  )
}
